import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=19c521fa&"
import script from "./AssetCard.vue?vue&type=script&lang=js&"
export * from "./AssetCard.vue?vue&type=script&lang=js&"
import style0 from "./AssetCard.vue?vue&type=style&index=0&id=19c521fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports